import { postWithoutBody } from 'utils/rxfetch'

export default () => ({
  startVisualScan(data) {
    return postWithoutBody('/visual/scan', { url: data.url, genuine: data.genuine })
  },
})
